<!--汇流箱清洁经济功能-->
<template>
	<div>
		<div class="buttonLine">
			<span style="margin-left: 20px;">汇流箱对比分析</span>
			<iconButton icoName="wedoButton/add.png" buttonText="指定已清洗汇流箱" @buttonClick='targetCleanedBox'></iconButton>
			<iconButton icoName="wedoButton/add.png" buttonText="指定未清洗汇流箱" @buttonClick='targetUnCleanedBox'></iconButton>
		</div>
		<infoList ref="propertyList" :columns='propertyColumns' :dataList="dataList" :pageLen='2' :totalSize="dataList.length"
		 :fillAll="true" :showIndex="false"></infoList>
		<div class="buttonLine">
			<p style="margin-left: 20px;">全站信息分析</p>
		</div>
		<infoList ref="propertyList2" :columns='propertyColumns2' :dataList="dataList2" :pageLen='1' :totalSize="dataList.length"
		 :fillAll="true" :showIndex="false"></infoList>
	</div>
</template>

<script>
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	export default {
		components: {
			infoList,
			iconButton,
			virtualDeviceTree,
		},
		props: {},
		data() {
			return {
				propertyColumns: [{
					name: '汇流箱名称',
					key: 'name',
				}, {
					name: '是否已清洗',
					key: 'isClean',
					weight: 0.5
				}, {
					name: '今日发电量',
					key: 'countToday'
				}, {
					name: '昨日发电量',
					key: 'countYestoday'
				}, {
					name: '支路数量',
					key: 'branchCount',
					weight: 0.5
				}, {
					name: '今日支路平均发电量',
					key: 'todayAvg'
				}, {
					name: '昨日支路平均发电量',
					key: 'yestodayAvg'
				}],
				propertyColumns2: [{
					name: '是否需要清洁',
					key: 'needClean',
					getTdStyleMethod(c, a, item) {
						var st = {}
						if (item == '是') {
							st = {
								color: "red"
							}
						} else if (item == '否') {
							st = {
								color: "green"
							}
						}
						return st
					}
				}, {
					name: '全站总支路数量',
					key: 'branchCount',
					weight: 0.5
				}, {
					name: '电费单价(元/kW·h)',
					key: 'price'
				}, {
					name: '清洁/不清洁总电费差额(元)',
					key: 'countSub'
				}, {
					name: '总清洁费用(元)',
					key: 'cleanCost'
				}, {
					name: '允许偏差量(元)',
					key: 'allowSub',
					weight: 0.5
				}],
				unCleanedBox: {
					name: '请指定未清洗汇流箱'
				},
				cleanedBox: {
					name: '请指定已清洗汇流箱'
				},
				idToPowerData: {},
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.$store.archivesStore.commit("getBindInfoMapByArchivesIdList", this.nowUnitAllArchivesList.map(item => item.id).join(
				','))
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.cleanedBoxVariableList.map(item => item.fromName).join(","))
			this.realTimeValueStore.commit("removeKeys", this.unCleanedBoxVariableList.map(item => item.fromName).join(","))
		},
		computed: {
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			nowArchivesBindMap() {
				//当前台账设备列表的绑定信息map
				return this.$store.archivesStore.getters.getBindInfoMapByArchivesIdList(this.nowUnitAllArchivesList.map(item =>
					item.id))
			},
			getArchivesBindInfo() {
				return pkid => {
					return this.nowArchivesBindMap[pkid]
				}
			},
			dataList() {
				this.unCleanedBox.branchCount = this.getBoxBranch(this.unCleanedBox.id).length

				this.cleanedBox.branchCount = this.getBoxBranch(this.cleanedBox.id).length
				return [this.unCleanedBox, this.cleanedBox]
			},
			dataList2() {
				if (this.unitSetting == undefined) {
					return []
				}
				var info = {
					needClean: "--",
					branchCount: parseFloat(this.unitSetting.UnitSetting___BranchCount),
					price: parseFloat(this.unitSetting.UnitSetting___Price),
					allowSub: parseFloat(this.unitSetting.UnitSetting___AllowableDeviation),
					countSub: "--",
					cleanCost: parseFloat(this.unitSetting.UnitSetting___CleanCost),
				}
				if (!isempty(this.cleanedBox.id) && !isempty(this.unCleanedBox.id)) {
					//计算差额
					var sub = this.cleanedBox.todayAvg - this.unCleanedBox.todayAvg
					//获取系数配置
					var GFModulus = 1
					if (DWSystemSetting.hasOwnProperty('GFModulus')) {
						GFModulus = DWSystemSetting.GFModulus
					}
					info.countSub = cutDigital(sub * info.branchCount * info.price * GFModulus)
					if (isNaN(info.countSub)) {
						info.countSub = "--"
						info.needClean = "--"
					} else {
						//判断是不是要清理
						if (info.countSub > info.allowSub + info.cleanCost) {
							info.needClean = "是"
						} else {
							info.needClean = "否"
						}
					}
				}
				return [info]
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			nowUnitArchivesTree() {
				//当前单位可以查看的台账设备树
				if (isempty(this.nowUnit)) {
					return undefined
				}
				return this.$store.archivesStore.getters.getArchivesTreeByUnitId(this.nowUnit.id)
			},
			nowUnitAllArchivesList() {
				if (this.nowUnitArchivesTree == undefined) {
					return []
				}
				return this.addArchivesListInfo(treeToList(this.nowUnitArchivesTree, 'next', item => item.entityName == 'AppClassType').filter(
					item => item.entityName ==
					"AppEquipmentArchives"))
			},
			unitSetting() {
				return this.nowUnitAllArchivesList.filter(item => item.typeCode == "UnitSetting")[0]
			},
			nowUnitBoxList() {
				//当前单位下可以选择的汇流箱列表,要过滤没有绑定虚拟设备组的
				return this.nowUnitAllArchivesList.filter(item => item.typeCode == "CustomConfluenceBox" && this.getArchivesBindInfo(
					item.id) != undefined)
			},
			getBoxVariableList() {
				//获取指定id的汇流箱的发电量变量列表
				return id => {
					var device = this.getArchivesBindInfo(id)
					if (device == undefined) {
						return []
					}
					var vl = this.$store.variableStore.getters.getVariableTree(device.no, [36])
					if (vl.length != 0) {
						return vl[0].next
					}
					return []
				}
			},
			getBoxBranch() {
				return id => {
					var device = this.getArchivesBindInfo(id)
					if (device == undefined) {
						return []
					}
					var vl = this.$store.variableStore.getters.getVariableTree(device.no, [262, 263, 264, 265, 266, 267, 268, 269,
						270, 271, 272, 273, 274, 275, 276, 277
					])
					if (vl.length != 0) {
						return vl[0].next
					}
					return []
				}
			},
			cleanedBoxVariableList() {
				//已清理汇流箱变量列表
				return this.getBoxVariableList(this.cleanedBox.id)
			},
			unCleanedBoxVariableList() {
				//已清理汇流箱变量列表
				return this.getBoxVariableList(this.unCleanedBox.id)
			},
			rtPower() {
				return id => {
					if (isempty(id)) {
						return '--'
					}
					var count = 0
					var list = this.realTimeValueStore.getters.getValue(this.getBoxVariableList(id).map(item => item.fromName))
					for (var i = 0, len = list.length; i < len; i++) {
						var item = list[i]
						if (!this.$historyTools.isNull(item)) {
							count += item
						}
					}
					return count
				}
			}
		},
		watch: {
			nowUnitAllArchivesList(nv, ov) {
				this.$store.archivesStore.commit("getBindInfoMapByArchivesIdList", nv.map(item => item.id).join(','))
			},
			nowUnitBoxList(nv, ov) {},
			cleanedBoxVariableList(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov.map(item => item.fromName))
				this.realTimeValueStore.commit("addKeys", nv.map(item => item.fromName))
				//查询历史数据
				this.searchHistory(nv, this.cleanedBox)
			},
			unCleanedBoxVariableList(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov.map(item => item.fromName))
				this.realTimeValueStore.commit("addKeys", nv.map(item => item.fromName))
				this.searchHistory(nv, this.unCleanedBox)
			},
		},
		methods: {
			targetCleanedBox() {
				//过滤出已经清理完毕的汇流箱
				var list = this.nowUnitBoxList.filter(item => item.CustomConfluenceBox___CleanState == '是')
				this.$dialogMethod.openSingleItemDialog("请指定已清理汇流箱", list, [this.cleanedBox.id], respon => {
					if (respon.length == 0) {
						this.$dialogMethod.showMessage("请选择一个汇流箱!")
						return
					}
					respon[0].isClean = '是'
					this.cleanedBox = respon[0]
				}, respon => {})
			},
			targetUnCleanedBox() {
				//过滤出已经清理完毕的汇流箱
				var list = this.nowUnitBoxList.filter(item => item.CustomConfluenceBox___CleanState == '否')
				this.$dialogMethod.openSingleItemDialog("请指定未清理汇流箱", list, [this.unCleanedBox.id], respon => {
					if (respon.length == 0) {
						this.$dialogMethod.showMessage("请选择一个汇流箱!")
						return
					}
					respon[0].isClean = '否'
					this.unCleanedBox = respon[0]
				}, respon => {})
			},
			addArchivesListInfo(archivesList) {
				//增加时间字符串
				var dateTools = new Date()
				for (var i = 0, len = archivesList.length; i < len; i++) {
					var item = archivesList[i]
					dateTools.setTime(item.createTime)
					item.createTimeText = dateTools.formatByTime()
				}
				//按照时间排序
				archivesList = archivesList.sort((a, b) => b.createTime - a.createTime)
				//增加属性值
				var list = []
				for (var i = 0, len = archivesList.length; i < len; i++) {
					var item = archivesList[i]
					this.$store.archivesStore.getters.getArchivesInfoById(item.id).forEach(it => {
						if (it.valueType == 7) {
							//如果是枚举,先找枚举列表
							var enumList = this.$store.enumStore.getters.getEnumByEnumCode(it.enumCode)
							if (!isempty(enumList.next)) {
								var Enum = enumList.next.find(e => {
									return e.pkid == it.value
								})
								item[it.typeCode + "___" + it.propertyCode] = Enum == undefined ? '' : Enum.itemText
							}
						} else {
							if (it.valueType == 6) {
								item[it.typeCode + "___" + it.propertyCode] = it.value == 1 ? "是" : "否"
							} else {
								item[it.typeCode + "___" + it.propertyCode] = it.value
							}
						}
					})
					list.push(item)
				}
				return list
			},
			searchHistory(variables, box) {
				if (variables.length == 0) {
					this.$set(box, 'countYestoday', '--')
					this.$set(box, 'countToday', '--')
					this.$set(box, 'yestodayAvg', '--')
					this.$set(box, 'todayAvg', '--')
					return
				}
				//查询昨日到现在的用电量
				var today = new Date().formatByDate("")
				var yestoday = new Date(Date.now() - 24 * 60 * 60 * 1000).formatByDate("")
				this.$api.historyApi.searchVariableHistory(variables.map(item => item.fromName).join(","), new Date(new Date().formatByDate())
					.getTime() - 24 * 60 * 60 * 1000, Date.now(), respon => {
						var countYestoday = 0
						var countToday = 0
						//处理每一个变量的数据
						eachObject(respon, item => {
							//把所有的0值移除，很烦人的，徳茵的设备会上来0
							if (item[yestoday] != undefined) {
								item[yestoday].data = item[yestoday].data.filter(it => it > 10)
							}
							if (item[today] != undefined) {
								item[today].data = item[today].data.filter(it => it > 10)
							}
							var yData = this.$historyTools.getSub(getValueIfNoNull(item[yestoday], {
								data: []
							}).data)
							var tData = this.$historyTools.getSub(getValueIfNoNull(item[today], {
								data: []
							}).data)
							countYestoday += parseFloat(yData)
							countToday += parseFloat(tData)
						})
						var yestodayAvg = isempty(box.branchCount) || box.branchCount == 0 ?
							'--' : cutDigital(countYestoday / box.branchCount)
						var todayAvg = isempty(box.branchCount) || box.branchCount == 0 ?
							'--' : cutDigital(countToday / box.branchCount)
						this.$set(box, 'countYestoday', isNaN(countYestoday) ? '--' : countYestoday)
						this.$set(box, 'countToday', isNaN(countToday) ? '--' : countToday)
						this.$set(box, 'yestodayAvg', yestodayAvg)
						this.$set(box, 'todayAvg', todayAvg)
					})
			}
		}
	}
</script>

<style scoped>

</style>
